import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import type { ErrorMessage, Workout, WorkoutUpdate } from 'types';
import { client } from 'utils/api-client';

function useEditAssignedWorkout(
  workoutId: string | undefined,
): UseMutationResult<AxiosResponse<Workout>, AxiosError<ErrorMessage>, WorkoutUpdate> {
  const queryClient = useQueryClient();

  return useMutation((workout: WorkoutUpdate) => client.put(`workouts/${workoutId}/`, workout), {
    onSuccess: () => {
      queryClient.invalidateQueries('workouts');
    },
  });
}

export default useEditAssignedWorkout;
